<template>
<ContentWrapper>
    <div class="content-heading">
      <div>프리톡 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/community/freeTalkList">프리톡 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search"/>
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
              <b-input-group class="mt-2 mb-1">
                <div class="form-check mb-2">
                  <input class="form-check-input" :id="`user-type-all`" v-model="data.selectAllUserType"
                    value="" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-all`">전체</label>
                </div>
                <div v-for="(item, index) in contentsUserTypes.array" :key="index" class="form-check mb-2 ml-3">
                  <input class="form-check-input" :id="`user-type-${index}`" v-model="data.selectedUserTypes" 
                    :value="item.value" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-${index}`">{{item.text}}</label>
                </div>
              </b-input-group>
            </div>

            <div class="col-auto">
              <label class="col-form-label">신고 여부</label>
            </div>
            <div class="col-auto">
              <b-form-select :options="data.warnCountOption.array" v-model="data.params.warnCountStr" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="7%" style="text-align:center" @click="localSort.sort('authorId')">작성자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('subject')" >주제<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('content')">내용<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="13%" style="text-align:center" @click="localSort.sort('regDt')" >등록일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('cmmtCount')">댓글<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('likeCount')">좋아요<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('warnCount')">신고<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="8">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{item.maskedAuthorId}}</td>
                <td class="align-middle text-center">{{item.subject}}</td>
                <td class="align-middle" @click="goUserChannel(index)">
                  <div :id="`contentsModule_${index}`" class="contentsModule">
                    <p class="collapse" :id="`collapseContents_${index}`">
                      {{item.content}}
                    </p>
                    <a role="button" href="javascript:void(0);" @click.stop="morePressed(index, $event);">더 보기</a>
                  </div>
                </td>
                <td class="align-middle text-center">{{item.regDt}}</td>
                <td class="align-middle text-center">
                  <a v-if="item.cmmtCount > 0" href="javascript:void(0);" @click="goCommentList(item.ftkSeq)">{{item.cmmtCount}}</a>
                  <span v-else>{{item.cmmtCount}}</span>
                </td>
                <td class="align-middle text-center">{{item.likeCount}}</td>
                <td class="align-middle text-center">{{item.warnCount}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<style scoped>
.contentsModule {
  font-size: 1rem;
  line-height: 1.5;
}

.contentsModule .collapse:not(.show) {
  display: block;
  height: 1.5rem;
  overflow: hidden;
}
</style>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, contentsUserTypes, ValueTexts} from "@/utils/Constants";
import * as comApi from "@/api/community/CommunityAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.params.warnYn = '';
      _dataObject.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
      _dataObject.selectAllUserType = computed({
        get() {
          return data.selectedUserTypes.length == contentsUserTypes.array.length;
        },
        set(newValue) {
          if (newValue) {
            data.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
          } else {
            data.selectedUserTypes = [];
          }
        }
      });
      const data = reactive(_dataObject);
      console.log('data.selectedUserTypes:', data.selectedUserTypes);

      data.schOptions = [
        {value:'authorId', text:'작성자'},
        {value:'subject', text:'주제'},
        {value:'content', text:'내용'},
      ];

      data.warnCountOption = new ValueTexts([
        {value:'', text:'전체'},
        {value:'1', text:'신고'},
        {value:'2', text:'미신고'},
      ]);

      const retVals = {
        isTest,
        modalLoading,
        contentsUserTypes,
        data,
        ...methods(data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        if (store.state.params.name == "freeTalkList") {
          const storedData = store.state.params.data;
          retVals.data.params = storedData.params;
          retVals.data.selectedUserTypes = storedData.userTypes;
          store.commit('setParams', {name:'', data:undefined});
        } else {
          retVals.reset();
        }
        await retVals.search();
      });

      return retVals;
    }
}

function methods(data) {

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:',data);

    data.params.warnCountStr = '';
    data.params.schType = '';
    data.params.schText = '';
  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    // typeCd 설정
    if (data.selectedUserTypes.length == 1) {
      data.params.typeCd = data.selectedUserTypes[0];
    } else {
      // length == 2 인 경우에도 '' 로 해서 전체 검색으로 전달한다.
      data.params.typeCd = '';
    }
    data.params.warnCount = parseInt(data.params.warnCountStr || '0');
    const result = await comApi.getFreeTalkList(data.params, this.isTest);
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  // 댓글 목록
  function goCommentList(ftkSeq) {
    this.$store.commit('setParams', {name:'freeTalkList', data:{userTypes:data.selectedUserTypes, params:data.params}});
    const name = 'freeTalkComment';
    const seq = parseInt(ftkSeq);
    this.$router.push({name:'freeTalkComment', params:{type:name, objectSeq:seq,
      schStartDt:data.params.schStartDt, schEndDt:data.params.schEndDt}});
  }

  // 게시글 더 보기
  function morePressed(index, event) {
    const collapse = $(`#collapseContents_${index}`);
    if (collapse.hasClass('show')) {
      collapse.removeClass('show');
    } else {
      collapse.addClass('show');
      $(event.target).hide();
    }
  }

  // 교사/강사 채널로 이동
  function goUserChannel(index) {
    const userHost = process.env.VUE_APP_LMS_USER_HOST;
    location.href = `${userHost}/login`;
    /*const typeCd = data.list[index].typeCd;
    if (typeCd == '105002') { // 교사채널
      location.href = userHost + '/login';
    } else { // 강사채널
      location.href = userHost + '/lt_p_00xx/tc_p_0003';
    }*/
  }

  return {
    resetSearch,
    reset,
    search,
    goCommentList,
    morePressed,
    goUserChannel
  }
}
</script>